export default {
}



// WEBPACK FOOTER //
// ./src/store/mp/vip_card/state.js